import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Nav/AdminSidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function AdminWalkInBooking() {
  const BASE = process.env.REACT_APP_SERVER_BASE_URL;
  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];

  // Customer state
  const [allCustomers, setAllCustomers] = useState([]);
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const [newCust, setNewCust] = useState({
    name: "",
    email: "",
    adhar_card: "",
    phone_number: "",
    address: "",
  });

  // Booking state
  const [checkIn, setCheckIn] = useState(today);
  const [checkOut, setCheckOut] = useState(tomorrow);
  const [numPeople, setNumPeople] = useState(1);
  const [purpose, setPurpose] = useState("");
  const [categories, setCategories] = useState([]);
  const [cat, setCat] = useState("");
  const [rooms, setRooms] = useState([]);
  const [available, setAvailable] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [total, setTotal] = useState(0);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState(null);

  // Fetch initial data
  useEffect(() => {
    fetch(`${BASE}/users/getAllCustomers.php`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => d.success && setAllCustomers(d.customers));
    fetch(`${BASE}/room/get-room-cat.php`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => d.success && setCategories(d.data));
  }, [BASE]);

  // Filter customer suggestions
  useEffect(() => {
    setFiltered(
      allCustomers.filter(
        (c) =>
          c.name.toLowerCase().includes(query.toLowerCase()) ||
          c.email.toLowerCase().includes(query.toLowerCase())
      )
    );
  }, [query, allCustomers]);

  // Fetch rooms by date
  useEffect(() => {
    if (!checkIn || !checkOut) return;
    fetch(
      `${BASE}/room/getRooms.php?check_in=${checkIn}&check_out=${checkOut}`,
      { credentials: "include" }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          setRooms(data.data);
        } else if (Array.isArray(data)) {
          setRooms(data); // fallback
        } else {
          setError("No rooms found");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError("Error fetching rooms");
      });
  }, [checkIn, checkOut]);

  // Filter by category
  useEffect(() => {
    setAvailable(
      rooms.filter((r) => parseInt(r.category_id) === parseInt(cat))
    );
    setSelectedRoom(null);
  }, [rooms, cat]);

  // Calculate total
  useEffect(() => {
    console.log(rooms);
    console.log("available:", available);
    if (!selectedRoom) return;
    const days = (new Date(checkOut) - new Date(checkIn)) / (1000 * 3600 * 24);
    setTotal(days > 0 ? days * parseFloat(selectedRoom.price) : 0);
  }, [selectedRoom, checkIn, checkOut]);

  // Submit booking
  // Check if all required fields are valid to enable the confirm button
  const canConfirmBooking = () => {
    const cust = isNew ? newCust : selectedCustomer;

    if (!cust) return false;

    // Customer must have either email or Aadhaar
    const hasContact = cust.email?.trim() || cust.adhar_card?.trim();
    if (!hasContact) return false;

    if (!checkIn || !checkOut) return false;
    if (!cat) return false;
    if (!selectedRoom) return false;
    if (!purpose.trim()) return false;
    if (numPeople < 1) return false;

    return true;
  };

  // Submit booking
  const submit = () => {
    const cust = isNew
      ? newCust
      : { customer_id: selectedCustomer.customer_id, ...selectedCustomer };

    if (!cust.email && !cust.adhar_card) {
      toast.error("Customer email or Aadhaar required");
      return;
    }
    if (!selectedRoom) {
      toast.error("Select a room");
      return;
    }
    if (!purpose) {
      toast.error("Add purpose of visit");
      return;
    }

    const payload = {
      ...cust,
      room_id: selectedRoom.room_id,
      num_of_people: numPeople,
      purpose_of_visit: purpose,
      check_in_time: checkIn,
      check_out_time: checkOut,
      amount: total,
    };

    fetch(`${BASE}/bookings/walk-in-bookings.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then((d) => {
        if (d.success) {
          toast.success("Booking successful!");
          setSelectedCustomer(null);
          setQuery("");
          setIsNew(false);
          setNewCust({
            name: "",
            email: "",
            adhar_card: "",
            phone_number: "",
            address: "",
          });
          setCat("");
          setSelectedRoom(null);
          setTotal(0);
          setPurpose("");
        } else {
          toast.error(`Error: ${d.message}`);
        }
      })
      .catch((err) => {
        toast.error("Network error: " + err.message);
      });
  };

  return (
    <div className="flex">
      <Sidebar />

      {/* Left: Booking Info */}
      <div className="flex-1 grid grid-rows-[auto_1fr_auto] m-4 space-y-6 bg-white p-6 rounded shadow">
        <h2 className="text-xl font-bold">Booking Details</h2>

        <div className="space-y-4">
          {/* Dates */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block">Check-in</label>
              <input
                type="date"
                value={checkIn}
                onChange={(e) => setCheckIn(e.target.value)}
                className="w-full p-2 border rounded"
              />
            </div>
            <div>
              <label className="block">Check-out</label>
              <input
                type="date"
                min={checkIn}
                value={checkOut}
                onChange={(e) => setCheckOut(e.target.value)}
                className="w-full p-2 border rounded"
              />
            </div>
          </div>

          {/* Category */}
          <div>
            <label className="block">Room Category</label>
            <select
              value={cat}
              onChange={(e) => setCat(e.target.value)}
              className="w-full p-2 border rounded"
            >
              <option value="">Select Category</option>
              {categories.map((c) => (
                <option key={c.category_id} value={c.category_id}>
                  {c.category_name}
                </option>
              ))}
            </select>
          </div>

          {/* Room selection as checkboxes */}
          {available.length > 0 && (
            <div>
              <label className="block mb-2">Available Rooms:</label>
              <div className="grid grid-cols-3 gap-3">
                {available.map((r) => (
                  <label
                    key={r.room_id}
                    className="flex items-center border rounded p-2 hover:bg-gray-50"
                  >
                    <input
                      type="radio"
                      name="room"
                      className="mr-2"
                      checked={selectedRoom?.room_id === r.room_id}
                      onChange={() => setSelectedRoom(r)}
                    />
                    {r.room_no} — ₹{r.price}
                  </label>
                ))}
              </div>
            </div>
          )}

          <div>
            <label>Number of People</label>
            <input
              type="number"
              min={1}
              className="p-2 border rounded w-24"
              value={numPeople}
              onChange={(e) => setNumPeople(e.target.value)}
            />
          </div>

          <div>
            <label>Purpose of Visit</label>
            <input
              type="text"
              className="p-2 border rounded w-full"
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
            />
          </div>

          {selectedRoom && (
            <div className="mt-4 text-lg font-semibold">
              Total Price: ₹{total.toFixed(2)}
            </div>
          )}
        </div>

        <button
          onClick={submit}
          disabled={!canConfirmBooking()}
          className={`mt-auto py-3 rounded text-white ${
            canConfirmBooking()
              ? "bg-blue-600 hover:bg-blue-700 cursor-pointer"
              : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          Confirm Booking
        </button>
      </div>

      {/* Right: Customer Info */}
      <div className="w-96 bg-white p-6 rounded m-4 shadow">
        <h2 className="text-lg font-bold">Customer Info</h2>

        {!isNew ? (
          <>
            <label className="block mt-4">Search Existing</label>
            <input
              type="text"
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                setSelectedCustomer(null);
              }}
              className="w-full p-2 border rounded"
              placeholder="Name or Email"
            />

            {!selectedCustomer &&
              filtered.slice(0, 5).map((c) => (
                <div
                  key={c.customer_id}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    setSelectedCustomer(c);
                    setQuery(`${c.name} (${c.email})`);
                  }}
                >
                  {c.name} — {c.email}
                </div>
              ))}

            <label className="flex items-center gap-2 mt-4">
              <input
                type="checkbox"
                checked={isNew}
                onChange={(e) => setIsNew(e.target.checked)}
              />
              Add New Customer
            </label>
          </>
        ) : (
          <label className="flex items-center gap-2 mt-4">
            <input
              type="checkbox"
              checked={!isNew}
              onChange={(e) => setIsNew(false)}
            />
            Select Existing Customer
          </label>
        )}

        {isNew && (
          <div className="space-y-3 mt-2">
            <input
              placeholder="Name"
              className="w-full p-2 border rounded"
              value={newCust.name}
              onChange={(e) => setNewCust({ ...newCust, name: e.target.value })}
            />
            <input
              placeholder="Email"
              className="w-full p-2 border rounded"
              value={newCust.email}
              onChange={(e) =>
                setNewCust({ ...newCust, email: e.target.value })
              }
            />
            <input
              placeholder="Aadhaar"
              className="w-full p-2 border rounded"
              value={newCust.adhar_card}
              onChange={(e) =>
                setNewCust({ ...newCust, adhar_card: e.target.value })
              }
            />
            <input
              placeholder="Phone"
              className="w-full p-2 border rounded"
              value={newCust.phone_number}
              onChange={(e) =>
                setNewCust({ ...newCust, phone_number: e.target.value })
              }
            />
            <textarea
              placeholder="Address"
              className="w-full p-2 border rounded"
              rows="2"
              value={newCust.address}
              onChange={(e) =>
                setNewCust({ ...newCust, address: e.target.value })
              }
            />
          </div>
        )}

        {selectedCustomer && !isNew && (
          <div className="mt-4 p-2 bg-gray-50 rounded">
            <div>
              <strong>{selectedCustomer.name}</strong>
            </div>
            <div>{selectedCustomer.email}</div>
            <div>{selectedCustomer.phone_number}</div>
          </div>
        )}
      </div>
      <ToastContainer
        position="top-center" // changed from bottom-right to top-center
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
}
